<template>
  <v-app style="background-color:white;margin-top:140px">
     <go-top></go-top>
     <div class="container">
         <v-layout row wrap>
             <v-flex md5 xs12 sm12>
                <img :src=item.src />
                
             </v-flex>

             <v-flex md7 xs12 sm12 style="text-align:left">
                <p class="txt"  style="font-weight:bold;font-size:18px">{{item.itemName}}
                    <span class="txt" style="color:grey">({{item.categoryName}})</span>
                </p>

                <p class="txt" style="font-weight:bold;padding-top:15px;">Description</p>
                <p class="txt">
                  {{item.description}}
                </p>
                   
                <h4 style="color:#246ed6">₹&nbsp;{{item.price.toFixed(2)}} <span style="font-size:14px;color:#212121;text-decoration: line-through;">₹&nbsp;{{item.mrp.toFixed(2)}}</span></h4>
              <p v-if="item.qty > 0" class="txt">Available Qty :&nbsp;{{item.qty}}</p>
              <p v-if="item.qty <= 0" style="color:red" class="txt">Out of Stock</p>
              <v-btn depressed color="#3381e8" large dark :disabled="item.qty<=0" @click="cart()">
                    <v-icon color="white">add_shopping_cart</v-icon>&nbsp;Order Now
                </v-btn>
              <v-btn depressed color="#FF3501" large dark :disabled="item.qty<=0" @click="cart()">
                    <v-icon color="white">add_shopping_cart</v-icon>&nbsp;Add to Cart
                </v-btn>
                <v-btn depressed color="#246ed6" large dark @click="wish()">
                    <v-icon color="white">favorite</v-icon>&nbsp;Add to Wishlist
                </v-btn>
              <!-- <p v-if="item.qty <= 0" style="text-align:left;color:red" class="covid">Out of Stock</p> -->
             </v-flex>
         </v-layout>
     </div>
  </v-app>
</template>

<script>
//import VueEasyLightbox from 'vue-easy-lightbox';
import GoTop from '@inotom/vue-go-top';
import config from "./../../config.json";
export default {
  components: {
    GoTop,
  },
  data() {
    return {
      valid: true,
      isLoading: false,
      text: null,
      read: false,
      item: {}
    };
  },
  
   mounted() {
       this.axios
        .get(config.API + `ProductDetails/${this.$route.params.id}`, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.item = res.data
        });
   },

 methods: {
     cart() {
     this.$store.commit('addToCart', this.item);
    },
    wish() {
     this.$store.commit('addToWish', this.item);
    },
     home(){
         this.$router.push(`/demo`);
     }
 },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@200&display=swap');
</style>

<style scoped>
.txt {
  font-family: 'Montserrat', sans-serif !important;
}
.about-us-img {
    background-image: url('https://sasitechnologies.in/csquad/assets/images/bg/bg-2.png');
    background-size: cover;
}
.zero {
    color: #4e97fd;
    font-size: 150px;
}
.covid {
  font-family: 'Quicksand', sans-serif;
  font-weight: bold;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.hvr :hover {
    color: #3486D7 !important;
}
</style>
